// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"261":"0cbca86e","285":"f541ebd2","482":"6769899d","768":"2e21950e","872":"0a526071","975":"991196b5"}[chunkId] + ".chunk.js";
};